import { create } from 'zustand';

// ----------------------------------------------------------------------

const logoStore = create((set) => ({
  photoURL: null,
  actions: {
    resetPhotoURL: () => set({ photoURL: null }),
    setPhotoURL: (photoURL) => set({ photoURL }),
  },
}));

export const useLogoStore = () => {
  const photoURL = logoStore((state) => state.photoURL);
  const actions = logoStore((state) => state.actions);

  return { photoURL, ...actions };
};
